import React from 'react';
import styles from './styles.module.scss';
import { Button, Icon } from 'components/antd';
import { roundNumber } from 'utils/converters';
import { BookingPrices } from 'AppClient/api/Bookings';
import ShowRating from 'components/ShowRating/ShowRating';
import { ProviderRow } from './ProviderRow';

interface Props {
	bookingPrice: BookingPrices;
	customerCurrencySymbol: string;
	isSelected: boolean;
	disabledAction?: boolean;
	hideAction?: boolean;
	onClickTermsAndConditions: (bookingPriceId: number) => void;
	setTermsAndConditionsAcceptModalType: (acceptModalType: boolean) => void;
}
export const ProviderRowActive: React.FC<Props> = props => {
	const {
		bookingPrice,
		customerCurrencySymbol,
		isSelected,
		disabledAction,
		hideAction,
		onClickTermsAndConditions,
		setTermsAndConditionsAcceptModalType,
	} = props;
	return (
		<ProviderRow
			providerName={bookingPrice.serviceProviderName}
			providerDescription={bookingPrice.serviceProviderDescription}
			isSelected={isSelected}
			bookingPriceId={bookingPrice.bookingPriceId}
			termsAndConditionsHandler={onClickTermsAndConditions}
			setTermsAndConditionsAcceptModalType={setTermsAndConditionsAcceptModalType}
		>
			<>
				<div>
					{bookingPrice.serviceProviderRating && (
						<ShowRating alignRight rating={bookingPrice.serviceProviderRating} />
					)}
					<span className={styles.providerCost}>
						{customerCurrencySymbol}
						&nbsp;
						{roundNumber(bookingPrice.totalPriceInCustomerCurrency)}
					</span>
				</div>
				{!hideAction && (
					<div className={styles.providerBtns}>
						{isSelected ? (
							<Icon type={'check'} />
						) : (
							<Button
								onClick={() => {
									onClickTermsAndConditions(bookingPrice.bookingPriceId);
									setTermsAndConditionsAcceptModalType(true);
								}}
								disabled={disabledAction}
								size="small"
								type="primary"
								key="action"
							>
								Accept
							</Button>
						)}
					</div>
				)}
			</>
		</ProviderRow>
	);
};
